import React, { useRef } from 'react';
import { Typography as AntdTypography } from 'antd';
import useViewportCheck from '../hooks/useViewportCheck'; // 수정한 훅을 import

const { Title: AntdTitle, Text: AntdText } = AntdTypography;

const getTitleFontSizes = (level) => {
  switch (level) {
    case 1: return { original: '2.375rem', wrapped: '1.8rem' };
    case 2: return { original: '1.875rem', wrapped: '1.4rem' };
    case 4: return { original: '1.25rem', wrapped: '1.0rem' };
    case 5: return { original: '1.0rem', wrapped: '0.9rem' };
    case 3:
    default: return { original: '1.5rem', wrapped: '1.2rem' };
  }
};

// --- 너비 기반 반응형 Title 컴포넌트 ---
const Title = ({ level = 3, children, style, ...rest }) => {
  const ref = useRef(null);
  // isWrapped 대신 isNarrow 라는 변수명으로 변경하여 가독성을 높입니다.
  const isNarrow = useViewportCheck();
  const { original, wrapped } = getTitleFontSizes(level);

  const dynamicStyle = {
    ...style,
    display: 'block',
    fontSize: isNarrow ? wrapped : original,
    transition: 'font-size 0.2s',
  };

  return <AntdTitle ref={ref} level={level} style={dynamicStyle} {...rest}>{children}</AntdTitle>;
};

// --- 너비 기반 반응형 Text 컴포넌트 ---
const Text = ({ children, style, ...rest }) => {
  const ref = useRef(null);
  const isNarrow = useViewportCheck();

  const dynamicStyle = {
    ...style,
    display: 'block',
    fontSize: isNarrow ? '0.9rem' : '1rem',
    transition: 'font-size 0.2s',
  };

  return <AntdText ref={ref} style={dynamicStyle} {...rest}>{children}</AntdText>;
};

const ResponsiveTypography = {
  Title,
  Text,
};

export default ResponsiveTypography;